import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function DashboardCard({ title, value }) {
  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Typography sx={{ fontSize: 20, fontWeight: "bold" }} gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 20, fontWeight: "bold" }} gutterBottom>
          {value}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" variant="contained">
          Check Now
        </Button>
      </CardActions>
    </Card>
  );
}
